var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page-container"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('span',{staticClass:"title-content"},[_vm._v(_vm._s(_vm.msg))]),_c('el-button',{attrs:{"size":"medium","type":"primary","plain":""},on:{"click":_vm.handleLogout}},[_vm._v("退出登录")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }